export default __webpack_public_path__ + "static/media/gregHarman.c07b6935.jpg";